module.exports = __webpack_public_path__ + "static/img/afg_choice_single.40ff2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afg_choice_single.png
// module id = WqvV
// module chunks = 1